export function supportEmailRequiredMessage() {
  return 'Informe o e-mail do suporte.'
}

export function supportNameRequiredMessage() {
  return 'Informe o nome do suporte.'
}

export function supportEmailInvalidMessage() {
  return 'Informe um e-mail válido.'
}

export function isValidSupportEmail(value: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}

export function validateProductSupport(input: {
  supportEmail: string
  supportName: string
}): Partial<Record<'supportEmail' | 'supportName', string>> {
  const errors: Partial<Record<'supportEmail' | 'supportName', string>> = {}
  const supportEmail = input.supportEmail.trim()
  const supportName = input.supportName.trim()

  if (!supportEmail) {
    errors.supportEmail = supportEmailRequiredMessage()
  } else if (!isValidSupportEmail(supportEmail)) {
    errors.supportEmail = supportEmailInvalidMessage()
  }

  if (!supportName) {
    errors.supportName = supportNameRequiredMessage()
  }

  return errors
}
